import HttpClient from '@/common/boot/HttpClient'

const listarAnaliticosProvedor = async ({ commit }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.post(
      '/analiticos-provedor/visualizar',
      payload
    )
    commit('LISTAR_DADOS', response.data.data.data)
    commit('ATUALIZAR_PAGINACAO', response.data.data)
    return response
  } catch (error) {
    console.error('Erro ao listar analíticos de provedor:', error)
    commit('LISTAR_DADOS', [])
    commit('ATUALIZAR_PAGINACAO', null)
  } finally {
    commit('CARREGANDO', false)
  }
}

const exportarAnaliticosProvedor = async ({ commit }, payload) => {
  commit('CARREGANDO', true)

  try {
    const response = await HttpClient.post(
      '/analiticos-provedor/exportar',
      payload,
      { responseType: 'blob' }
    )

    const contentType =
      response.headers['content-type'] || 'application/octet-stream'
    const blob = new Blob([response.data], { type: contentType })

    const disposition = response.headers['content-disposition']
    let fileName = 'analiticos-provedor-exportacao'

    if (disposition) {
      const match = disposition.match(/filename="?(.+?)"?$/)
      if (match && match[1]) {
        fileName = match[1]
      }
    }

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Erro ao exportar analíticos de provedor:', error)
  } finally {
    commit('CARREGANDO', false)
  }
}

const listarDetalhesAnaliticosProvedor = async ({ commit }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.post(
      '/analiticos-provedor/visualizar-provedor',
      payload
    )

    const payloadResponse = response?.data?.data

    commit('LISTAR_DADOS', payloadResponse?.data || [])
    commit('ATUALIZAR_PAGINACAO', payloadResponse)

    return response
  } catch (error) {
    console.error('Erro ao listar detalhes analíticos de provedor:', error)
    commit('LISTAR_DADOS', [])
    commit('ATUALIZAR_PAGINACAO', null)
  } finally {
    commit('CARREGANDO', false)
  }
}

export {
  listarAnaliticosProvedor,
  exportarAnaliticosProvedor,
  listarDetalhesAnaliticosProvedor,
}
